import * as Logger from 'loglevel';

const version = require('../../package.json').version;

export const environment = {
  defaultLanguage: 'de',
  enableTranslator: true,
  hmr: false,
  logLevel: Logger.levels.WARN,
  production: true,
  version,
  withBranding: true,
};
